import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from "@angular/core";
import { interval } from "rxjs";
import { ReportStatus } from "src/app/constants/report-status";

import { Report } from "src/app/models/reports";
import { AgentCRMService } from "src/app/services/agent-crm.service";
import { HelperService } from "src/app/services/helper.service";

@Component({
    selector: 'mwp-reports-today',
    templateUrl: './reports-today.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ReportsTodayComponent implements OnInit, OnDestroy {
    public reports: Report[];
    public intervalSubsribtion: any;

    constructor(
        private agentCRMService: AgentCRMService,
        private helperService: HelperService,
    ) {
    }

    ngOnInit(): void {
        this.buildReports();
        this.intervalSubsribtion = interval(15000).subscribe(() => {
            this.buildReports();
        });
    }

    ngOnDestroy(): void {
        this.intervalSubsribtion.unsubscribe();
    }

    private buildReports(): void {
        this.agentCRMService.getTodaysReports().subscribe((respone: Report[]) => {
            let l_CancelInterval: boolean = true;
            respone.forEach((r: Report) => {
                r.status = this.helperService.getTypeOfValue(ReportStatus, r.status);
                if (r.status == ReportStatus.E || r.status == ReportStatus.S)
                    l_CancelInterval = false;
            });

            if (l_CancelInterval)
                this.intervalSubsribtion.unsubscribe();
            this.reports = respone;
        });
    }
}